export interface IExtraData {}

export enum EField {
  Info = "_info",
  WhiseId = "WhiseId",
}
